import { render } from "./Home.vue?vue&type=template&id=0e5d7b4a"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
script.render = render

export default script